import React, { useState } from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { useLocation, useNavigate } from 'react-router-dom';
import DeliveryReport from './DeliveryReport';
import PreviewTemplateModal from './PreviewTemplateModal'; // Modal for previewing email templates
import Recipients from './Recipients';
import ReportsAutomationOverview from './ReportsAutomationOverview';
import ReportsViewAutomationTable from './ReportsViewAutomationTable';

// Sample data for delivery report
const deliveryData = [
  // Array of objects representing email delivery records
  {
    id: 1,
    recipient: 'Customer A',
    email: 'a@email.com',
    sent: '15-08-2025',
    status: 'Delivered',
  },
  {
    id: 2,
    recipient: 'Customer B',
    email: 'b@email.com',
    sent: '15-08-2025',
    status: 'Not Delivered',
  },
  {
    id: 3,
    recipient: 'Customer C',
    email: 'c@email.com',
    sent: '24-08-2025',
    status: 'Bounced',
  },
  {
    id: 4,
    recipient: 'Customer D',
    email: 'd@email.com',
    sent: '15-08-2025',
    status: 'Delivered',
  },
  {
    id: 5,
    recipient: 'Customer E',
    email: 'e@email.com',
    sent: '15-08-2025',
    status: 'Not Delivered',
  },
  {
    id: 6,
    recipient: 'Customer F',
    email: 'f@email.com',
    sent: '24-08-2025',
    status: 'Bounced',
  },
  {
    id: 7,
    recipient: 'Customer G',
    email: 'g@email.com',
    sent: '24-08-2025',
    status: 'Bounced',
  },
];

// Sample data for recipient details
const recipientData = [
  // Array of objects representing recipient details
  {
    id: 1,
    name: 'John Doe',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Political'],
    lastOpened: '15-08-2025',
    lastClicked: '15-08-2025',
    openRate: '80%',
    clickRate: '60%',
    emailsReceived: 100,
    emailsOpened: 80,
    emailsClicked: 60,
    lastActive: '15-08-2025',
    engagementScore: 82,
    unsubscribed: 'No',
  },
  {
    id: 2,
    name: 'Brad Pitt',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Sports'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '90%',
    clickRate: '70%',
    emailsReceived: 150,
    emailsOpened: 120,
    emailsClicked: 80,
    lastActive: '24-08-2025',
    engagementScore: 84,
    unsubscribed: 'No',
  },
  {
    id: 3,
    name: 'Robert Pattinson',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'Old User',
    tags: ['Entertainment'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '85%',
    clickRate: '65%',
    emailsReceived: 120,
    emailsOpened: 90,
    emailsClicked: 60,
    lastActive: '24-08-2025',
    engagementScore: 90,
    unsubscribed: 'No',
  },
  {
    id: 4,
    name: 'Tom Cruise',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Political'],
    lastOpened: '15-08-2025',
    lastClicked: '15-08-2025',
    openRate: '80%',
    clickRate: '60%',
    emailsReceived: 100,
    emailsOpened: 80,
    emailsClicked: 60,
    lastActive: '15-08-2025',
    engagementScore: 67,
    unsubscribed: 'No',
  },
  {
    id: 5,
    name: 'Bruce Willis',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Sports'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '90%',
    clickRate: '70%',
    emailsReceived: 150,
    emailsOpened: 120,
    emailsClicked: 80,
    lastActive: '24-08-2025',
    engagementScore: 50,
    unsubscribed: 'No',
  },
  {
    id: 6,
    name: 'Mel Gibson',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'Old User',
    tags: ['Entertainment'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '85%',
    clickRate: '65%',
    emailsReceived: 120,
    emailsOpened: 90,
    emailsClicked: 60,
    lastActive: '24-08-2025',
    engagementScore: 70,
    unsubscribed: 'No',
  },
  {
    id: 7,
    name: 'Arnold Schwarzenegar',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Political'],
    lastOpened: '15-08-2025',
    lastClicked: '15-08-2025',
    openRate: '80%',
    clickRate: '60%',
    emailsReceived: 100,
    emailsOpened: 80,
    emailsClicked: 60,
    lastActive: '15-08-2025',
    engagementScore: 60,
    unsubscribed: 'No',
  },
  {
    id: 8,
    name: 'Sylvestor Stallone',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Sports'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '90%',
    clickRate: '70%',
    emailsReceived: 150,
    emailsOpened: 120,
    emailsClicked: 80,
    lastActive: '24-08-2025',
    engagementScore: 85,
    unsubscribed: 'No',
  },
  {
    id: 9,
    name: 'Jackie Chan',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'Old User',
    tags: ['Entertainment'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '85%',
    clickRate: '65%',
    emailsReceived: 120,
    emailsOpened: 90,
    emailsClicked: 60,
    lastActive: '24-08-2025',
    engagementScore: 69,
    unsubscribed: 'No',
  },
];

// Sample data for automation campaigns
const automationTable: any[] = [
  {
    id: '1',
    name: 'Campaign Name 1',
    type: 'Newsletter',
    status: 'Active',
    recipients: '15,000',
    openRate: '14.1%',
    clickRate: '6.8%',
    triggerDate: '15-08-2025',
    action: 'View',
    subtitle: 'Your Morning Brief: Top Headlines for Today',
    segment: 'West Bengal, Bihar, Odisha',
    tags: ['Politics', 'Sports', 'Entertainment'],
    deliveredDate: 'Tue, Aug 02, 2025 09:00 AM',
    stats: {
      sent: 500,
      delivered: 400,
      opened: 350,
      clicked: 300,
      bounced: 10,
      spamReported: 10,
      openRate: '14.1%',
      clickRate: '6.8%',
      newSubscribers: 10,
      unsubscribes: 2,
    },
    lastOpened: { name: 'John Doe', time: '3 Aug 25, 09:00 AM' },
    lastClicked: { name: 'John Doe', time: '3 Aug 25, 09:00 AM' },
  },
  {
    id: '2',
    name: 'Campaign Name 2',
    type: 'Promotion',
    status: 'Active',
    recipients: '15,000',
    openRate: '15.6%',
    clickRate: '7.6%',
    triggerDate: '15-08-2025',
    action: 'View',

    // Extra details for ViewCampaign
    subtitle: 'Your Morning Brief: Top Headlines for Today',
    segment: 'West Bengal, Bihar, Odisha',
    tags: ['Politics', 'Sports', 'Entertainment'],
    deliveredDate: 'Tue, Aug 02, 2025 09:00 AM',
    stats: {
      sent: 500,
      delivered: 400,
      opened: 350,
      clicked: 300,
      bounced: 10,
      spamReported: 10,
      openRate: '15.6%',
      clickRate: '7.6%',
      newSubscribers: 10,
      unsubscribes: 2,
    },
    lastOpened: { name: 'John Doe', time: '3 Aug 25, 09:00 AM' },
    lastClicked: { name: 'John Doe', time: '3 Aug 25, 09:00 AM' },
  },

  {
    id: '3',
    name: 'Campaign Name 3',
    type: 'Newsletter',
    status: 'Active',
    recipients: '15,000',
    openRate: '14.1%',
    clickRate: '6.8%',
    triggerDate: '15-08-2025',
    action: 'View',

    // Extra details for ViewCampaign
    subtitle: 'Your Morning Brief: Top Headlines for Today',
    segment: 'West Bengal, Bihar, Odisha',
    tags: ['Politics', 'Sports', 'Entertainment'],
    deliveredDate: 'Tue, Aug 02, 2025 09:00 AM',
    stats: {
      sent: 500,
      delivered: 400,
      opened: 350,
      clicked: 300,
      bounced: 10,
      spamReported: 10,
      openRate: '14.1%',
      clickRate: '6.8%',
      newSubscribers: 10,
      unsubscribes: 2,
    },
    lastOpened: { name: 'John Doe', time: '3 Aug 25, 09:00 AM' },
    lastClicked: { name: 'John Doe', time: '3 Aug 25, 09:00 AM' },
  },
  {
    id: '4',
    name: 'Campaign Name 4',
    type: 'Promotion',
    status: 'Active',
    recipients: '15,000',
    openRate: '15.6%',
    clickRate: '7.6%',
    triggerDate: '15-08-2025',
    action: 'View',

    // Extra details for ViewCampaign
    subtitle: 'Your Morning Brief: Top Headlines for Today',
    segment: 'West Bengal, Bihar, Odisha',
    tags: ['Politics', 'Sports', 'Entertainment'],
    deliveredDate: 'Tue, Aug 02, 2025 09:00 AM',
    stats: {
      sent: 500,
      delivered: 400,
      opened: 350,
      clicked: 300,
      bounced: 10,
      spamReported: 10,
      openRate: '15.6%',
      clickRate: '7.6%',
      newSubscribers: 10,
      unsubscribes: 2,
    },
    lastOpened: { name: 'John Doe', time: '3 Aug 25, 09:00 AM' },
    lastClicked: { name: 'John Doe', time: '3 Aug 25, 09:00 AM' },
  },
];

// Type casting for icons to ensure compatibility with React
const FiChevronLeftComponent = FiChevronLeft as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;
// const FiMailComponent = FiMail as unknown as React.ComponentType<{
//   size?: number | string;
//   className?: string;
// }>;

// StatBox component to display individual statistics
// const StatBox: React.FC<{ label: string; value: string | number }> = ({
//   label,
//   value,
// }) =>
//   label !== 'New Subscribers' &&
//   label !== 'Unsubscribes' &&
//   label !== 'Last Opened' &&
//   label !== 'Last Clicked' ? (
//     // Standard stat box for most metrics
//     <div className='bg-white rounded-md p-3 flex items-center justify-between border border-gray-200 shadow-sm'>
//       <div>
//         <h3 className='text-[#657584] text-[14px] mb-2 font-semibold'>
//           {label}
//         </h3>
//         <p className='text-[28px] text-[#3F5265] font-semibold'>{value}</p>
//       </div>
//       <div>
//         <span className='flex items-center justify-center mr-2 w-[30px] h-[30px] rounded-[5px] bg-[#FFF1EC]'>
//           <FiMailComponent className='text-orange-500 text-2xl' size={17} />
//         </span>
//       </div>
//     </div>
//   ) : (
//     // Modified stat box for specific metrics with different styling
//     <div
//       className={`bg-white ${
//         label === 'New Subscribers' ? 'rounded-t' : 'rounded-b'
//       } p-[13.5px] flex items-center justify-between border border-gray-200 shadow-sm`}
//     >
//       <div className='flex justify-between items-center w-[100%]'>
//         <h3 className='text-[#18181B] text-[14px] font-semibold'>{label}</h3>
//         <p className='text-[20px] text-[#3F5265] font-semibold'>{value}</p>
//       </div>
//     </div>
//   );

// Main component for viewing automation details
const ReportsViewAutomation: React.FC = () => {
  const navigate = useNavigate();
  const { state: automation } = useLocation();
  // State to manage active tab (overview, delivery, or recipients)
  const [activeTab, setActiveTab] = useState<
    'overview' | 'delivery' | 'recipients'
  >('overview');
  // State to control modal visibility for email preview
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Handle case where no automation data is provided
  if (!automation) {
    return <div className='p-6'>No campaign data</div>;
  }

  return (
    <div className='p-2'>
      {/* Back button to navigate to previous page */}
      <button
        onClick={() => navigate(-1)}
        className='flex items-center text-sm text-teal-600 mb-4 hover:underline font-semibold'
        style={{ color: '#00899E', fontSize: '14px' }}
      >
        <FiChevronLeftComponent className='mr-1' /> Back to Reports
      </button>

      {/* Header section */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <h2 className='text-[20px] font-bold text-[#3F5265]'>
            View Automation
          </h2>
          <p className='text-[#657584] mb-6 text-[16px]'>
            Automation performance and analytics
          </p>
        </div>
      </div>

      {/* Automation details header */}
      <div className='bg-white p-4 rounded-lg mb-6 border border-gray-200 shadow-sm'>
        <div className='flex justify-between items-start'>
          <div>
            <h2 className='text-xl font-semibold text-[#1F2937] text-[18px]'>
              {automation.name}
            </h2>
            <p className='text-gray-500'>{automation.subtitle}</p>
          </div>
          <div className='flex items-center gap-3'>
            <button
              onClick={() =>
                activeTab === 'overview' ? null : setIsModalOpen(true)
              }
              className='text-[#FF7A59] px-3 py-2 rounded hover:bg-orange-50 text-sm border border-[#FF7A59] text-[14px]'
            >
              {activeTab === 'overview' ? 'View Flow' : 'Preview Email'}
            </button>
          </div>
        </div>
        <div className='flex flex-wrap gap-2 mt-5 text-sm text-gray-600 bg-[#F5F8FA] p-3 rounded justify-between'>
          <span className='text-[#9FA9B2] text-[12px]'>
            SEGMENT{' '}
            <span className='text-[#263445] text-[16px] ml-2'>
              {automation.segment}
            </span>
          </span>
          <span className='text-[#9FA9B2] text-[12px]'>
            TAGS{' '}
            <span className='text-[#263445] text-[16px] ml-2'>
              {automation.tags.join(', ')}
            </span>
          </span>
          <span className='text-[#9FA9B2] text-[12px]'>
            DELIVERED{' '}
            <span className='text-[#263445] text-[16px] ml-2'>
              {automation.deliveredDate}
            </span>
          </span>
        </div>
      </div>

      {/* Tab navigation */}
      <div className='flex gap-6 mt-2'>
        <button
          onClick={() => setActiveTab('overview')}
          className={`pb-2 ${activeTab === 'overview'
            ? 'border-b-2 border-[#00899E] text-[#00899E] font-semibold'
            : 'text-gray-500'
            }`}
        >
          Overview
        </button>
        <button
          onClick={() => setActiveTab('delivery')}
          className={`pb-2 ${activeTab === 'delivery'
            ? 'border-b-2 border-[#00899E] text-[#00899E] font-semibold'
            : 'text-gray-500'
            }`}
        >
          Delivery Report
        </button>
        <button
          onClick={() => setActiveTab('recipients')}
          className={`pb-2 ${activeTab === 'recipients'
            ? 'border-b-2 border-[#00899E] text-[#00899E] font-semibold'
            : 'text-gray-500'
            }`}
        >
          Recipients
        </button>
      </div>

      {/* Tab content */}
      <div className={activeTab === 'overview' ? 'py-6' : ''}>
        {activeTab === 'overview' && (
          <>
            <ReportsAutomationOverview automation={automation} />
            <ReportsViewAutomationTable automations={automationTable} />
          </>
        )}

        {activeTab === 'delivery' && (
          <DeliveryReport deliveryData={deliveryData} />
        )}

        {activeTab === 'recipients' && (
          <Recipients
            recipients={recipientData}
            c={automation?.id}
            fromtab='automations'
          />
        )}
      </div>
      {/* Modal for previewing email templates */}
      <PreviewTemplateModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default ReportsViewAutomation;
